<template>
  <div>
    <div>
      <social-buttons
        :buttons="socialSignUpButtons"
        :loading="social.loading"
      ></social-buttons>
      <div class="delimiter">
        <text-delimiter :text="delimiterText"></text-delimiter>
      </div>
    </div>
    <modal-dialog-wechat-qr-code
      v-if="featureSwitchesState.CANDIDATE_WECHAT_SIGNUP"
      :modal-name="wechatModal"
      :action="action"
      @on-close="$emit('cancel-sign-up')">
    </modal-dialog-wechat-qr-code>
  </div>
</template>

<script>

import TextDelimiter from 'top20common/components/text-blocks/TextDelimiter';
import {mapGetters} from 'vuex';

import ModalDialogWechatQrCode from '@/common/social/ModalDialogWechatQrCode';
import SocialButtons from '@/common/social/SocialButtons';
import socialsMixin from '@/mixins/socialsMixin';

const WECHAT_MODAL = 'wechat-signup-modal';

export default {
  mixins: [socialsMixin],
  props: {
    loading: Boolean
  },
  data() {
    return {
      social: {
        loading: false
      },
      wechatModal: WECHAT_MODAL,
      action: 'register',
      delimiterText: this.$gettext('or')
    };
  },
  computed: {
    ...mapGetters(['featureSwitchesState']),
    linkedInButtonConfig() {
      return {
        label: this.$gettext('Sign up with LinkedIn'),
        onClick: this.onSignUpWithLinkedInClick
      };
    },
    wechatButtonConfig() {
      return {
        label: this.$gettext('Sign up with WeChat'),
        color: 'is-green',
        onClick: this.onSignUpWithWechatClick
      };
    },
    socialSignUpButtons() {
      let buttons = [];

      if (this.featureSwitchesState.CANDIDATE_WECHAT_SIGNUP && this.$mq.desktop) {
        buttons.push(this.wechatButtonConfig);
      }

      if (this.featureSwitchesState.CANDIDATE_LINKEDIN_SIGNUP) {
        buttons.push(this.linkedInButtonConfig);
      }

      return buttons;
    }
  },
  methods: {
    onSignUpWithLinkedInClick() {
      this.setSocialLoading();
      this.$emit('start-sign-up');
      this.$mam.trackLinkedInSignUpClicked(this.$route.query.action);
      window.location.href = this.getLinkedInConnectUrl('register');
    },
    onSignUpWithWechatClick() {
      this.$emit('start-sign-up');
      this.$modal.show(this.wechatModal);
    },
    setSocialLoading() {
      this.social.loading = true;
    }
  },
  components: {
    ModalDialogWechatQrCode,
    SocialButtons,
    TextDelimiter
  }
};
</script>

<style lang="scss" scoped>
@import '~VariablesStyles';

@media (max-width: $tablet) {
  .delimiter {
    position: relative;
    left: -20px;
    width: calc(100% + 40px);
  }
}
</style>
